//#region IMPORT
import React from 'react';
import { Button, Dialog } from '../../../../Components/MUIs';
import { Box, Stack, Chip, TextField, Typography } from '@mui/material';
import Canvas from '../../../../Components/Canvas/Canvas';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { AgGridReact } from 'ag-grid-react';
import { getColumnDefs1, getColumnDefs2 } from './SAF_BASIC_02_ColumnDefs';

function SAF_BASIC_02(props) {
  //#region 웹
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2();

  return (
    <>
      <BusinessCommon
        title1={'안전작업허가서 기본정보'}
        title2={'안전작업허가서 미리보기'}
        gridId={props.gridId1}
        getRowId={(params) => {
          return params.data.no;
        }}
        addYn1={'N'}
        deleteYn1={'Y'}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1(props.searchRef.current.custCd);
        }}
        deleteClick1={(e) => {
          // 그리드에서 현재 선택된 모든 노드를 직접 가져옴
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi?.getSelectedNodes() || [];
          const selectedData = selectedNodes.map((n) => n.data);

          if (!selectedData || selectedData.length === 0) {
            return;
          }

          const newRowExists = selectedData.some((row) => row.newYn === 'Y');

          if (!newRowExists) {
            props.MarkedForDeletion1(selectedData);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'multiple'}
        onCellClicked={(e) => {
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'coNm');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection1(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef1.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        onCellValueChanged={(e) => {
          const key = e.data.no;

          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter((row) => row.no !== key);
            return [...filtered, { ...e.data }];
          });
        }}
        // 미리보기
        viewMode="preview"
        selectedRowData={props.selectedRowData1}
        fileNameField="saveName"
        filePathField="filePath"
      />
      {props.modalToggle1 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={<>반려사유</>}
            open={props.modalToggle1}
            onClose={(e) => props.setModalToggle1(false)}
            contentSx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            fullWidth
            saveButtonName={'반려처리'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={false}
            maxWidth="sm"
            onSave={() => {
              const reason = props.rejectReason ?? ''; // undefined/null 방지
              if (typeof reason === 'string' && reason.trim()) {
                props.RejectLogic(reason.trim());
                props.setModalToggle1(false); // 정상 입력 시에만 닫기
              } else {
                // 경고 메시지 띄우고 모달은 닫지 않음
                props.dispatch(
                  props.showSnackbar({
                    message: '반려 사유를 입력하세요.',
                    type: 'warning',
                  })
                );
              }
            }}
            content={
              <TextField
                label="반려 사유를 입력하세요"
                multiline
                rows={6}
                variant="outlined"
                fullWidth
                value={props.rejectReason}
                onChange={(e) => props.setRejectReason(e.target.value)}
                placeholder="사유를 입력하세요"
                inputProps={{ maxLength: 256 }}
              />
            }
          />
        </div>
      )}

      {props.modalToggle2 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Dialog
            title="서명등록"
            open={props.modalToggle2}
            onClose={() => props.setModalToggle2(false)}
            contentSx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              padding: 3,
              maxHeight: '90vh',
              overflow: 'auto',
            }}
            fullWidth
            maxWidth="sm" // 팝업 너비 확장
            saveButtonName={null} // 별도 확인 버튼 아래 넣었기 때문에 숨김
            closeButtonName={'닫기'}
            useSaveButton={false}
            useSaveAfterClose={false}
            content={
              <Stack gap={2}>
                {/* 헤더 우측 재설정 버튼 */}
                <Box display="flex" justifyContent="flex-end">
                  <Chip
                    sx={{ borderRadius: '8px' }}
                    label="재설정"
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      props.signatureCanvas.current.clear();
                      props.setSignInputs({
                        mapUrl: '',
                        mapFiles: {},
                      });
                    }}
                    // disabled={
                    //   props.alarmData.find(
                    //     (f) => f.id === Commons.DecryptoAES(props.userInfo.userid)
                    //   )?.checkYn === '확인'
                    // }
                  />
                </Box>

                {/* 서명 캔버스 영역 */}
                <Box
                  sx={{
                    border: '1px solid #ccc',
                    borderRadius: 2,
                    padding: 1,
                  }}
                >
                  <Canvas
                    signatureCanvas={props.signatureCanvas}
                    userId={props.userInfo?.userNm}
                    imageUrl={props.signInputs.mapUrl}
                    // disabled={
                    //   props.alarmData.find(
                    //     (f) => f.id === Commons.DecryptoAES(props.userInfo.userid)
                    //   )?.checkYn === '확인'
                    // }
                    onEnd={(e) => {
                      if (props.signatureCanvas.current) {
                        const signatureDataUrl =
                          props.signatureCanvas.current.toDataURL('image/png');

                        const decodedData = atob(
                          signatureDataUrl.split(',')[1]
                        );
                        const byteNumbers = new Array(decodedData.length);
                        for (let i = 0; i < decodedData.length; i++) {
                          byteNumbers[i] = decodedData.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                          type: 'image/png',
                        });

                        props.setSignInputs({
                          mapUrl: signatureDataUrl,
                          mapFiles: new File(
                            [blob],
                            `${new Date()
                              .toISOString()
                              .replace(/T/, '')
                              .replace(/\..+/, '')
                              .replace(/-/g, '')
                              .replace(/:/g, '')}.png`,
                            {
                              type: 'image/png',
                            }
                          ),
                        });
                      }
                    }}
                  />
                </Box>

                {/* 안내 문구 */}
                <Typography
                  sx={{ textAlign: 'center', color: 'text.secondary' }}
                >
                  [필수] 서명 정보 수집 및 이용에 동의합니다.
                </Typography>

                {/* 확인 버튼 */}
                <Button
                  sx={{
                    width: '100%',
                    height: '36px',
                    borderRadius: '18px',
                    backgroundColor: '#2DB400',
                    '&:hover': {
                      backgroundColor: '#26a300',
                    },
                  }}
                  onClick={() => {
                    props.ApproveLogic('2', props.signInputs.mapUrl);
                    props.setModalToggle2(false);
                  }}
                  name="확인"
                  // disabled={
                  //   props.alarmData.find(
                  //     (f) => f.id === Commons.DecryptoAES(props.userInfo.userid)
                  //   )?.checkYn === '확인'
                  // }
                >
                  확인
                </Button>
              </Stack>
            }
          />
        </div>
      )}

      {props.modalToggle3 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={<>반려이력</>}
            open={props.modalToggle3}
            onClose={(e) => props.setModalToggle3(false)}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            // saveButtonName={'선택'}
            closeButtonName={'닫기'}
            //useSaveButton={true}
            useSaveAfterClose={true}
            maxWidth="md"
            onSave={() => {
              //handleManageSelection();
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <AgGridReact
                  ref={props.gridRef4}
                  animationRows={true}
                  columnDefs={columnDefs2}
                  rowData={props.modalRowData3}
                  defaultColDef={{
                    cellDataType: false,
                    minWidth: 100,
                    editable: false,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                  }}
                  //rowSelection="single"
                  // onSelectionChanged={() => {
                  //   GridFunctions.onSelectionChanged(
                  //     props.gridRef4,
                  //     (_selected) => {
                  //       props.setSelectedModalRowData4(_selected);
                  //     }
                  //   );
                  // }}
                  getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
              </div>
            }
          />
        </div>
      )}
    </>
  );
}

export default SAF_BASIC_02;
